import { onMounted, ref, watch } from "vue";
import { nextTick } from "vue";
import { useStore } from "vuex";
import { GetCountries } from "@/server/api/roaming/get-countries.get";
import { GetCountriesByZone } from "@/server/api/roaming/countries-by-zone.get";
import { GetZoneByUuid } from "@/server/api/roaming/get-zone-by.get";
import type {
  RoamingCountryStruct,
  RoamingZoneStruct,
} from "@/struct/RoaminStruct";
import type { Ref } from "vue";

export function useRoamingView(roamingInfoTitle: Ref<HTMLElement | null>) {
  const store = useStore();

  const selectedCountry = ref<RoamingCountryStruct | null>(null);
  const selectedZone = ref<RoamingZoneStruct | null>(null);
  const othersCountriesList = ref<RoamingCountryStruct[] | null>(null);
  const othersCountriesCount = ref(0);
  const popularCountries = ref<RoamingCountryStruct[] | null>(null);
  const isSticky = ref<boolean>(false);

  const getPopular = () => {
    GetCountries("", true)
      .then((countries) => {
        popularCountries.value = countries;
      })
      .catch((err) => {
        console.log("Error get popular counters: ", err);
      });
  };

  const selectCountry = (country: RoamingCountryStruct) => {
    selectedCountry.value = country;
  };

  const getZone = async (uuidZone: string) => {
    await GetZoneByUuid(uuidZone)
      .then((zone) => {
        selectedZone.value = zone;
      })
      .catch((err) => {
        selectedZone.value = null;
        console.log("error get counters", err);
      });
  };

  const getOthersCountries = (uuidZone: string) => {
    GetCountriesByZone(uuidZone)
      .then((data) => {
        othersCountriesList.value = data.countries;
        othersCountriesCount.value = data.count;
      })
      .catch((err) => {
        othersCountriesList.value = null;
        othersCountriesCount.value = 0;
        console.log("error get others counters", err);
      });
  };

  const identicalCountriesWithActive = (itemUuid: string) => {
    return itemUuid === selectedCountry.value?.uuid;
  };

  watch(
    () => selectedCountry.value,
    async (newSelectedCountry) => {
      if (newSelectedCountry?.roaming_zone_uuid) {
        await getZone(newSelectedCountry.roaming_zone_uuid);
        nextTick(() => {
          if (roamingInfoTitle.value) {
            roamingInfoTitle.value.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        });
        getOthersCountries(newSelectedCountry.roaming_zone_uuid);
      } else {
        selectedZone.value = null;
        othersCountriesList.value = null;
        othersCountriesCount.value = 0;
      }
    }
  );

  onMounted(() => {
    getPopular();
  });

  return {
    identicalCountriesWithActive,
    isSticky,
    othersCountriesList,
    othersCountriesCount,
    popularCountries,
    selectedCountry,
    selectedZone,
    selectCountry,
  };
}
